module.exports = __webpack_public_path__ + "static/media/video.4f1c7602.mp4";